import { render, staticRenderFns } from "./question-detail.vue?vue&type=template&id=06100108&scoped=true"
import script from "./question-detail.vue?vue&type=script&lang=ts"
export * from "./question-detail.vue?vue&type=script&lang=ts"
import style0 from "./question-detail.vue?vue&type=style&index=0&id=06100108&prod&scoped=true&lang=scss"
import style1 from "./question-detail.vue?vue&type=style&index=1&id=06100108&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06100108",
  null
  
)

export default component.exports